import { render, staticRenderFns } from "./Promotion_product_exp.vue?vue&type=template&id=98e7230e&scoped=true&"
import script from "./Promotion_product_exp.vue?vue&type=script&lang=js&"
export * from "./Promotion_product_exp.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_product_exp.vue?vue&type=style&index=0&id=98e7230e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e7230e",
  null
  
)

export default component.exports